import { render, staticRenderFns } from "./MmplEditAppr.vue?vue&type=template&id=282dabbe&scoped=true&"
import script from "./MmplEditAppr.vue?vue&type=script&lang=js&"
export * from "./MmplEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282dabbe",
  null
  
)

export default component.exports